import { apiCallback } from 'api';

export default {
  post: apiCallback(
    {
      service: 'pims',
      endpoint: 'pims/products-by-recipe',
      verbs: ['post'],
      defaultVersion: 1,
    },
    'post',
  ),
};
